import {Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import Button from '@mui/material/Button'
import React from 'react'

type DatasetType = {
    dataset_id?: string | null;
    dataset_name?: string | null;
    filter_applied?: any | null;
}

type AppliedDatasetFilterProps = {
    open: boolean;
    onClose: () => void;
    dataset?: DatasetType;
}

const AppliedDatasetFilterDialog = ({open, onClose, dataset}: AppliedDatasetFilterProps) => {
    return (
        <Dialog
            open={open}
            keepMounted
            onClose={onClose}
            aria-describedby="applied-dataset-filter-dialog"
        >
            <DialogTitle variant='h5'>{dataset?.dataset_id + ' | ' + dataset?.dataset_name}</DialogTitle>
            <DialogContent>
                {dataset?.filter_applied &&
                        <pre>{JSON.stringify(dataset.filter_applied, null, 2)}</pre>}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" size="small">Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AppliedDatasetFilterDialog